/** @format */

import React from "react"
import {
  createMuiTheme,
  Button,
  Radio,
  TextField,
  Dialog,
  InputAdornment,
  makeStyles,
  MuiThemeProvider,
  Select as MatSelect,
} from "@material-ui/core"
import { Formik, Field, Form } from "formik"
import Fieldz from "../../../../functions/Fieldz"
import * as Yup from "yup"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../redux"
import jalaali from "jalaali-js"
import { Input, Select } from "../../../../_metronic/_partials/controls"
import plateIMG from "../../../../ebusHomePics/Pelak.png"
import moment from "moment-jalaali"
import DatePicker, { Calendar, utils } from "react-modern-calendar-datepicker"

// ../ebusHomePics/Pelak.png
export default (props) => {
  const [selectedDay, setSelectedDay] = React.useState(null)
  const departuredDateRef = React.useRef(null)
  const dispatch = useDispatch()
  const ownerState = useSelector((state) => state.owner)
  console.log("ownerState in secend page", ownerState)
  const def = ownerState.ownerInfo.car

  const theme = createMuiTheme({
    overrides: {
      MuiOutlinedInput: {
        root: {
          "& $notchedOutline": {
            border: "none",
          },
        },
      },
    },
  })

  const renderCustomInput = ({ ref }) => (
    <input
      readOnly
      ref={ref} // necessary
      placeholder="تاریخ انقضای بیمه"
      value={
        selectedDay
          ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
          : ""
      }
      style={{
        color: "gray",

        paddingRight: "10px",
        border: "1px solid #e4e6ef",
        height: "52px",
        borderRadius: "14px",
        width: "100%",

        // boxShadow: "0 1.5rem 2rem rgba(156, 136, 255, 0.2)",

        outline: "blue 1px",
      }}
      className="my-custom-input-class" // a styling class
    />
  )

  const CustomerEditSchema = Yup.object().shape({
    ownerStats: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    brandId: Yup.number()
      .min(2, "لطفا وارد کنید")
      .required("پر کردن فیلد الزامی است"),

    tip: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    model: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    seatNumber: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    color: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    engineNumber: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    chassicNumber: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    vin: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    smartCardNumber: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    insuranceNumber: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    // insuranceDate: Yup.string("پر کردن فیلد الزامی است")
    //   .required("پر کردن فیلد الزامی است")
    //   .typeError("پر کردن فیلد الزامی است"),
    companyName: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
    plateSeries: Yup.string("پر کردن فیلد الزامی است")
      .required("پر کردن فیلد الزامی است")
      .typeError("پر کردن فیلد الزامی است"),
  })

  console.log("props.stepEdit.edit==========", props.stepEdit.edit)
  return (
    <div className="p-5">
      <Formik
        enableReinitialize
        validationSchema={props.stepEdit.edit ? null : CustomerEditSchema}
        initialValues={{
          brandId: def.brandId,
          chassicNumber: def.chassicNumber,
          color: def.color,
          companyName: def.companyName,
          engineNumber: def.engineNumber,
          insuranceDate: def.insuranceDate,
          insuranceNumber: def.insuranceNumber,
          model: def.model,
          ownerStats: def.ownerStats,
          plateNumber: def.plateNumber,
          plateSeries: def.plateSeries,
          seatNumber: def.seatNumber,
          seatNumber: def.seatNumber,
          smartCardNumber: def.smartCardNumber,
          tip: def.tip,
          vin: def.vin,
        }}
        onSubmit={(values) => {
          console.log("theirdvalues", values)
          if (props.stepEdit.edit) {
            console.log("omadam")

            values.plateNumber = `${values.plateNumber3}n${values.plateNumber1}`
            console.log("omadam 2 ")

            const newValue = {
              car: { ...def, ...values },
            }
            console.log("omadam 2.5", def)

            dispatch(
              actions.getAllOwnerInfo({
                ...ownerState.ownerInfo,
                car: newValue,
              })
            )
            console.log("omadam 3")

            props.handleComplete()
          } else {
            const miladi = moment(
              `${selectedDay.year} /${selectedDay.month} / ${selectedDay.day}`,
              "jYYYY/jM/jD"
            ).format("YYYY-MM-DD")

            values.insuranceDate = miladi
            values.carCode = values.vin
            values.plateNumber = `${values.plateNumber3}n${values.plateNumber1}`

            delete values.plateNumber1
            delete values.plateNumber2
            delete values.plateNumber3

            dispatch(
              actions.getAllOwnerInfo({ ...ownerState.ownerInfo, car: values })
            )
            console.log("false car", values)
            props.handleComplete()
          }
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => {
          return (
            <>
              <h2
                className="col-4 col-md-3"
                style={{
                  borderBottom: "3px solid #6dd06d",
                  padding: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                <b>مشخصات وسیله نقلیه</b>
              </h2>
              <div className="row d-flex">
                <Radio
                  checked={values.ownerStats === "1"}
                  onChange={() => setFieldValue("ownerStats", "1")}
                />
                <h6 className="my-auto mr-5">مالک</h6>
                <Radio
                  checked={values.ownerStats === "0"}
                  onChange={() => setFieldValue("ownerStats", "0")}
                />
                <h6 className="my-auto">شراکتی</h6>
              </div>
              {touched.ownerStats && errors.ownerStats && (
                <h6 className="my-auto text-danger mr-auto">
                  {errors.ownerStats}
                </h6>
              )}

              <h4 style={{ marginBlock: "3rem 1rem" }}>
                <b>مشخصات کارت ماشین</b>
              </h4>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.brandId}
                    name="brandId"
                    component={Input}
                    placeholder="برند"
                    // placeholder="سیستم"
                  />
                  {errors.brandId && touched.brandId ? (
                    <b className="text-danger mt-1">{errors.brandId}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.tip}
                    name="tip"
                    component={Input}
                    placeholder="تیپ"
                  />
                  {touched.tip && errors.tip ? (
                    <b className="text-danger mt-1">{errors.tip}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.model}
                    name="model"
                    component={Input}
                    placeholder="مدل"
                  />
                  {touched.model && errors.model ? (
                    <b className="text-danger mt-1">{errors.model}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.seatNumber}
                    name="seatNumber"
                    component={Input}
                    placeholder="تعداد صندلی"
                  />
                  {touched.seatNumber && errors.seatNumber ? (
                    <b className="text-danger mt-1">{errors.seatNumber}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.color}
                    name="color"
                    component={Input}
                    placeholder="رنگ"
                  />
                  {touched.color && errors.color ? (
                    <b className="text-danger mt-1">{errors.color}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.engineNumber}
                    name="engineNumber"
                    component={Input}
                    placeholder="شماره موتور"
                  />
                  {touched.engineNumber && errors.engineNumber ? (
                    <b className="text-danger mt-1">{errors.engineNumber}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.chassicNumber}
                    name="chassicNumber"
                    component={Input}
                    placeholder="شماره شاسی"
                  />
                  {touched.chassicNumber && errors.chassicNumber ? (
                    <b className="text-danger mt-1">{errors.chassicNumber}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.vin}
                    name="vin"
                    component={Input}
                    placeholder="VIN"
                  />
                  {touched.vin && errors.vin ? (
                    <b className="text-danger mt-1">{errors.vin}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.smartCardNumber}
                    name="smartCardNumber"
                    component={Input}
                    placeholder="شماره کارت هوشمند"
                  />
                  {touched.smartCardNumber && errors.smartCardNumber ? (
                    <b className="text-danger mt-1">{errors.smartCardNumber}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5 d-flex">
                  <div className="col-3">
                    <TextField
                      defaultValue={def.plateSeries}
                      className="mx-auto  w-100"
                      name="plateSeries"
                      fullWidth
                      max="99"
                      onChange={(e) => {
                        setFieldValue("plateSeries", e.target.value)
                      }}
                      style={{ height: "4rem" }}
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <h5
                              style={{ marginBottom: "4rem" }}
                              className="mr-auto"
                            >
                              <span style={{ fontFamily: "sans" }}> ایران</span>
                            </h5>
                          </InputAdornment>
                        ),
                        style: { direction: "ltr" },
                      }}
                    />
                    {touched.plateSeries && errors.plateSeries ? (
                      <b className="text-danger mt-1">{errors.plateSeries}</b>
                    ) : null}
                  </div>
                  <div
                    className="col-7 p-0"
                    style={{
                      borderRadius: "7px 13px 13px 7px",
                      border: "1px solid #d9d9d9",
                      height: "4rem",
                    }}
                  >
                    <MuiThemeProvider theme={theme}>
                      <TextField
                        className="w-25 h-100 font-16"
                        variant="outlined"
                        type="number"
                        max="99"
                        InputProps={{
                          style: { fontSize: "16px", fontFamily: "sans" },
                        }}
                        onChange={(e) => {
                          setFieldValue("plateNumber3", e.target.value)
                        }}
                      />

                      <TextField
                        className="w-25 h-100 font-16"
                        variant="outlined"
                        type="number"
                        placeholder="ع"
                        disabled
                        max="99"
                        InputProps={{
                          style: { fontSize: "16px", fontFamily: "sans" },
                        }}
                      />

                      <TextField
                        className="w-50 h-100"
                        variant="outlined"
                        type="number"
                        max="999"
                        onChange={(e) => {
                          setFieldValue("plateNumber1", e.target.value)
                        }}
                        InputProps={{
                          style: { fontSize: "16px", fontFamily: "sans" },
                        }}
                      />
                    </MuiThemeProvider>
                    <img
                      src={plateIMG}
                      className="h-100"
                      style={{
                        position: "absolute",
                        left: "0px",
                        top: "0px",
                      }}
                    />
                  </div>
                </div>
              </div>

              <h4 style={{ marginBlock: "3rem 1rem" }}>
                <b>مشخصات کارت بیمه</b>
              </h4>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.insuranceNumber}
                    name="insuranceNumber"
                    component={Input}
                    placeholder="کد یکتای بیمه نامه"
                  />
                  {touched.insuranceNumber && errors.insuranceNumber ? (
                    <b className="text-danger mt-1">{errors.insuranceNumber}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <DatePicker
                    name="insuranceDate"
                    value={selectedDay}
                    onChange={setSelectedDay}
                    renderInput={renderCustomInput}
                    shouldHighlightWeekends
                    locale="fa" // add this
                  />
                  ر{" "}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.companyName}
                    name="companyName"
                    component={Input}
                    placeholder="شرکت بیمه"
                  />
                  {touched.companyName && errors.companyName ? (
                    <b className="text-danger mt-1">{errors.companyName}</b>
                  ) : null}
                </div>
              </div>

              <div
                className="d-flex align-items-center flex-wrap"
                style={{ marginBlock: "3rem 2rem" }}
              >
                <div className="col-12 col-md-6 my-3">
                  <Button
                    className="w-100"
                    style={{
                      height: "4rem",
                      backgroundColor: "#6dd06d",
                      borderRadius: "13px",
                    }}
                    onClick={() => {
                      handleSubmit()
                    }}
                  >
                    <h6 className="my-auto text-white">مرحله بعد</h6>
                  </Button>
                </div>
                <div className="col-12 col-md-6  my-3">
                  <Button
                    onClick={() => {}}
                    className="w-100"
                    style={{
                      height: "4rem",
                      backgroundColor: "#d9d9d9",
                      borderRadius: "13px",
                    }}
                  >
                    <h6 className="my-auto text-white">بازگشت</h6>
                  </Button>
                </div>
              </div>
            </>
          )
        }}
      </Formik>
    </div>
  )
}
